import { ROUTES } from '@analyzer/utils/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceId/portfolio/')(
  {
    beforeLoad({ params }) {
      throw redirect({ to: ROUTES.portfolioClauses, params })
    },
  }
)
